export default "/_next/static/images/1541ef9f5950cba8414ecf47bf1ed43c.png";